export const CATEGORIES = [
  { id:"todos",label:"Todos",emoji:"⭐" },
  { id:"comidas",label:"Comidas",emoji:"🍽️" },
  { id:"snacks",label:"Snacks",emoji:"🍿" },
  { id:"bebidas",label:"Bebidas",emoji:"🥤" },
  { id:"frutas",label:"Frutas",emoji:"🍓" },
  { id:"menu_semanal",label:"Menú Semanal",emoji:"📋" },
];

export const DAY_CODES = ["L","K","M","J","V"];
export const DAY_NAMES = { L:"Lun", K:"Mar", M:"Mié", J:"Jue", V:"Vie" };
export const DAY_INDEX_TO_CODE = { 1:"L", 2:"K", 3:"M", 4:"J", 5:"V" }; // JS getDay(): 1=Mon

// Check if product is available right now (or for a specific date)
export function isProductAvailable(product, forDate) {
  if (!product.active) return false;
  const d = forDate ? new Date(forDate) : new Date();
  const dayOfWeek = d.getDay(); // 0=Sun, 1=Mon...
  const dayCode = DAY_INDEX_TO_CODE[dayOfWeek];
  if (!dayCode) return false; // weekend
  const days = product.availableDays || DAY_CODES;
  if (!days.includes(dayCode)) return false;
  // Check hour only if forDate is not specified (real-time check)
  if (!forDate) {
    const maxH = product.maxHour || "23:59";
    const [mh, mm] = maxH.split(":").map(Number);
    const now = new Date();
    if (now.getHours() > mh || (now.getHours() === mh && now.getMinutes() > mm)) return false;
  }
  return true;
}

// For scheduling: check if product is available on a specific day
// If the day is today, also check the max hour
export function isProductAvailableForDay(product, dateStr) {
  if (!product.active) return false;
  const d = new Date(dateStr + "T12:00:00");
  const dayOfWeek = d.getDay();
  const dayCode = DAY_INDEX_TO_CODE[dayOfWeek];
  if (!dayCode) return false;
  const days = product.availableDays || DAY_CODES;
  if (!days.includes(dayCode)) return false;
  // If scheduling for today, check max hour
  const today = new Date().toISOString().slice(0, 10);
  if (dateStr === today) {
    const maxH = product.maxHour || "23:59";
    const [mh, mm] = maxH.split(":").map(Number);
    const now = new Date();
    if (now.getHours() > mh || (now.getHours() === mh && now.getMinutes() > mm)) return false;
  }
  return true;
}

export const GRADES = [
  "Kinder","Preparatoria","Primero","Segundo","Tercero","Cuarto",
  "Quinto","Sexto","Séptimo","Octavo","Noveno","Décimo","Undécimo","Administrativo"
];

export const EMOJI_OPTIONS = [
  // Platos principales
  "🍔","🌮","🌯","🥗","🍜","🍲","🥘","🧆","🍱","🍙","🍚","🍛","🍝","🍠","🫔","🥩","🍗","🍖","🥓","🌭","🍕","🫕","🥫","🍣","🍤","🦐","🥚","🍳","🧈",
  // Sopas y caldos
  "🫙","🥣","🍶",
  // Snacks y antojitos
  "🍟","🥨","🧂","🫘","🥜","🌰","🍿","🧇","🥞","🥐","🍞","🫓","🥖","🥙",
  // Postres y dulces
  "🍰","🎂","🧁","🍩","🍪","🍫","🍬","🍭","🍮","🍯","🍡","🍧","🍨","🍦","🥧","🍢",
  // Frutas
  "🍎","🍊","🍋","🍌","🍍","🥭","🍓","🍇","🍉","🍑","🍒","🫐","🥝","🍈","🍏","🍐","🥥","🫒",
  // Verduras
  "🌽","🥕","🥦","🧅","🧄","🥔","🍆","🥑","🌶️","🫑","🥒","🥬","🌿",
  // Bebidas
  "☕","🍵","🧋","🥤","🧃","💧","🍹","🥛","🫖","🍼",
  // Extras útiles
  "🎁","⭐","❤️","🌟","🔥","✨","🏆","🎉","💚","🍴","🥄"
];

export const EMOJI_NAMES = {
  // Platos principales
  "🍔": "hamburguesa burger", "🌮": "taco tortilla", "🌯": "wrap burritto",
  "🥗": "ensalada vegetal", "🍜": "sopa fideos ramen", "🍲": "olla cazuela sopa",
  "🥘": "paella arroz cazuela", "🧆": "croqueta falafel", "🍱": "bento almuerzo",
  "🍙": "arroz bola", "🍚": "arroz blanco", "🍛": "curry arroz",
  "🍝": "pasta espagueti spaghetti", "🍠": "camote papa dulce",
  "🫔": "tamal envuelto", "🥩": "carne bistec steak res",
  "🍗": "pollo pechuga muslo", "🍖": "costilla carne hueso",
  "🥓": "tocino bacon", "🌭": "perro caliente hot dog salchicha",
  "🍕": "pizza", "🫕": "fondue olla", "🥫": "lata conserva",
  "🍣": "sushi pescado", "🍤": "camarón empanizado", "🦐": "camarón marisco",
  "🥚": "huevo", "🍳": "huevo frito sartén", "🧈": "mantequilla",
  // Sopas
  "🫙": "frasco tarro conserva", "🥣": "bowl tazón cereal sopa",
  "🍶": "sake tazón",
  // Snacks
  "🍟": "papas fritas", "🥨": "pretzel pan", "🧂": "sal",
  "🫘": "frijoles garbanzos lentejas", "🥜": "maní cacahuate nuez",
  "🌰": "castaña nuez", "🍿": "palomitas popcorn",
  "🧇": "waffle gofre", "🥞": "pancakes hotcakes",
  "🥐": "croissant pan", "🍞": "pan", "🫓": "pan pita flatbread",
  "🥖": "baguette pan frances", "🥙": "pita sandwich wrap",
  // Postres
  "🍰": "pastel torta cake", "🎂": "torta pastel cumpleaños cake",
  "🧁": "cupcake muffin", "🍩": "dona rosquilla",
  "🍪": "galleta cookie", "🍫": "chocolate",
  "🍬": "dulce caramelo", "🍭": "paleta chupeta caramelo",
  "🍮": "flan natilla pudín", "🍯": "miel",
  "🍡": "mochi dulce", "🍧": "raspado helado",
  "🍨": "helado nieve", "🍦": "helado cono",
  "🥧": "pie tarta", "🍢": "brocheta",
  // Frutas
  "🍎": "manzana roja", "🍊": "naranja mandarina",
  "🍋": "limón", "🍌": "banano plátano",
  "🍍": "piña ananas", "🥭": "mango",
  "🍓": "fresa frutilla", "🍇": "uvas",
  "🍉": "sandía patilla", "🍑": "durazno melocotón",
  "🍒": "cereza", "🫐": "mora arándano",
  "🥝": "kiwi", "🍈": "melón",
  "🍏": "manzana verde", "🍐": "pera",
  "🥥": "coco", "🫒": "aceituna oliva",
  // Verduras
  "🌽": "maíz elote choclo", "🥕": "zanahoria",
  "🥦": "brócoli", "🧅": "cebolla",
  "🧄": "ajo", "🥔": "papa patata",
  "🍆": "berenjena", "🥑": "aguacate palta",
  "🌶️": "chile picante jalapeño", "🫑": "pimiento chile dulce",
  "🥒": "pepino", "🥬": "lechuga espinaca",
  "🌿": "hierba cilantro perejil",
  // Bebidas
  "☕": "café coffee", "🍵": "té tea",
  "🧋": "bubble tea boba", "🥤": "refresco soda",
  "🧃": "jugo zumo néctar", "💧": "agua water",
  "🍹": "cóctel tropical", "🥛": "leche milk",
  "🫖": "tetera", "🍼": "biberón leche",
  // Extras
  "🎁": "regalo especial", "⭐": "estrella especial",
  "❤️": "corazón amor", "🌟": "estrella destacado",
  "🔥": "fuego picante hot", "✨": "especial premium",
  "🏆": "trofeo mejor", "🎉": "celebración fiesta",
  "💚": "saludable natural", "🍴": "cubiertos tenedor",
  "🥄": "cuchara"
};

export const FMT = (c) => "\u20A1" + c.toLocaleString();
export const MLABELS = { sinpe:"SINPE Móvil 📱",transfer:"Transferencia 🏦",cash:"Efectivo 💵",credito:"Crédito 💳",efectivo:"Efectivo 💵" };
export const MLABELS_PLAIN = { sinpe:"SINPE Movil",transfer:"Transferencia",cash:"Efectivo",credito:"Crédito",efectivo:"Efectivo" };

export const fmtDate = (d) => new Date(d).toLocaleDateString("es-CR",{day:"2-digit",month:"short"});
export const fmtTime = (d) => new Date(d).toLocaleTimeString("es-CR",{hour:"2-digit",minute:"2-digit"});
export const fmtDateTime = (d) => `${fmtDate(d)} · ${fmtTime(d)}`;
export const fmtDateFull = (d) => new Date(d).toLocaleDateString("es-CR",{weekday:"long",day:"numeric",month:"long",year:"numeric"});

export function getWeekRange(date) {
  const d = new Date(date);
  const day = d.getDay();
  const mon = new Date(d); mon.setDate(d.getDate() - ((day + 6) % 7));
  mon.setHours(0,0,0,0);
  const sun = new Date(mon); sun.setDate(mon.getDate() + 6);
  sun.setHours(23,59,59,999);
  return { start: mon, end: sun };
}

export function getWeekDays(date) {
  const { start } = getWeekRange(date);
  const days = [];
  const labels = ["Lunes","Martes","Miércoles","Jueves","Viernes"];
  for (let i = 0; i < 5; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push({ date: d, label: labels[i], dateStr: d.toISOString().slice(0,10) });
  }
  return days;
}

export async function getNextStudentCode(db, schoolId) {
  if (!schoolId) throw new Error("getNextStudentCode requires schoolId");
  const { collection, getDocs } = await import("firebase/firestore");
  const snap = await getDocs(collection(db, "schools", schoolId, "students"));
  let max = 0;
  snap.docs.forEach(d => {
    const code = d.data().code;
    if (code) { const n = parseInt(code.replace("EST","")); if (n > max) max = n; }
  });
  return "EST" + String(max + 1).padStart(5, "0");
}

export const CSS = `@import url('https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600;700&family=Baloo+2:wght@500;600;700;800&family=DM+Sans:wght@400;500;600;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0}
@keyframes floatB{0%{transform:translateY(0) rotate(0)}100%{transform:translateY(-30px) rotate(10deg)}}
@keyframes popIn{0%{transform:scale(0)}100%{transform:scale(1)}}
@keyframes bounceIn{0%{transform:scale(.3);opacity:0}50%{transform:scale(1.05)}70%{transform:scale(.95)}100%{transform:scale(1);opacity:1}}
@keyframes confetti{0%{transform:translateY(0) rotate(0);opacity:1}100%{transform:translateY(100vh) rotate(720deg);opacity:0}}
@keyframes wiggle{0%,100%{transform:rotate(-3deg)}50%{transform:rotate(3deg)}}
@keyframes slideUp{from{transform:translateY(30px);opacity:0}to{transform:translateY(0);opacity:1}}
@keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
@keyframes slideR{from{transform:translateX(40px);opacity:0}to{transform:translateX(0);opacity:1}}
@keyframes pPulse{0%,100%{opacity:1}50%{opacity:.6}}
@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
input:focus,button:focus{outline:none}
::-webkit-scrollbar{width:6px}::-webkit-scrollbar-track{background:transparent}::-webkit-scrollbar-thumb{background:#CBD5E1;border-radius:3px}`;
